import { render, staticRenderFns } from "./OrdersBadge.vue?vue&type=template&id=41b8372b&"
import script from "./OrdersBadge.vue?vue&type=script&lang=js&"
export * from "./OrdersBadge.vue?vue&type=script&lang=js&"
import style0 from "./OrdersBadge.vue?vue&type=style&index=0&id=41b8372b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports